import React from "react";
import { Component } from "react";
import actions from "actions";
import GroupMembersList from "../../../components/Admin/StudyGroups/GroupMembers/GroupMembersList";
import Toolbar from "../../../components/Admin/StudyGroups/GroupMembers/Toolbar";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { API_ADMIN_STUDY_GROUP_INVITES } from "../../../constants/api";

const { getGroupInvites, deleteInvite } = actions;

const approveInvitation = (id) =>
  axios.put(`${API_ADMIN_STUDY_GROUP_INVITES}/${id}`);

class GroupMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      per_page: 25,
      query: {
        title: "",
        ...props.query,
      },
    };
  }

  componentWillMount() {
    this.loadGroupInvites();
  }

  loadGroupInvites = () => {
    const { params, getGroupInvites } = this.props;
    const { page, per_page, query } = this.state;

    getGroupInvites(params.id, { page, per_page, query });
  };

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadGroupInvites, timeout);
    });
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.setState({ page: 1 }, () => {
      this.loadGroupInvites(query);
    });
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.loadGroupInvites
    );
  };

  handleApprove = async (id) => {
    try {
      await approveInvitation(id);
      toast.success("Invitation has been approved!");
      this.loadGroupInvites();
    } catch (error) {
      console.log(error);
    }
  };

  cancelInvitation = (inviteId) => {
    const { deleteInvite } = this.props;

    deleteInvite(inviteId);
  };

  render() {
    const { params } = this.props;
    return (
      <div>
        <Toolbar
          count={this.props.count}
          deleteMembers={this.deleteMembers}
          groupId={params.id}
        />
        <GroupMembersList
          {...this.props}
          cancelInvitation={this.cancelInvitation}
          paginationProps={{
            onChangePage: this.onChangePage,
            page: this.state.page,
            total_pages: this.props.total_pages,
          }}
          handleApprove={this.handleApprove}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  groupInvites: state.studygroups.groupInvites.values,
  query: state.studygroups.groupInvites.query,
  page: state.studygroups.groupInvites.page,
  per_page: state.studygroups.groupInvites.per_page,
  total_pages: state.studygroups.groupInvites.total_pages,
  count: state.studygroups.groupInvites.count,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  getGroupInvites: (id, params) => dispatch(getGroupInvites(id, params)),
  deleteInvite: (inviteId) => dispatch(deleteInvite(inviteId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupMembers);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/GroupMembers.jsx